// src/components/PublicLayout.js
import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

const PublicLayout = () => {
  return (
    <>
      <Header />
      <main>
        {/* The <Outlet> component will render the matched child route component */}
        {/* (e.g., Home, About, Contact) */}
        <Outlet />
      </main>
      <Footer />
    </>
  );
};

export default PublicLayout;